// 此处用于存放所有登录相关的接口请求
import request from '@/utils/request'

// 1. 获取图形验证码
export const getPicCode = () => {
  return request.get('/captcha')
}

// 2. 获取短信验证码
export const getMsgCode = (captchaCode, captchaKey, mobile) => {
  return request.post('/captcha/sendSmsCaptcha', {
    form: {
      captchaCode,
      captchaKey,
      mobile
    }
  })
}

// 3. 登录接口
export const codeLogin = (username, password, code, uuid, bol) => {
  return request.get('/check2', {
    params: {
      password: password,
      username: username,
      code: code,
      bol: bol,
      uuid: uuid
    }
  })
}

// 3. 查询接口
export const codeLoginCheck = (username, password, code, uuid, bol) => {
  return request.get('/rbCheckLogin', {
    params: {
      password: password,
      username: username,
      code: code,
      bol: bol,
      uuid: uuid
    }
  })
}
